import React, { useState, useEffect } from "react";
import { Canvas, useThree } from "@react-three/fiber";
import { OrbitControls, useGLTF } from "@react-three/drei";

const Model = () => {
  const { scene } = useGLTF("./Models/Glitch/space.glb");
  const [scale, setScale] = useState(0.5);
  const [position, setPosition] = useState([0, -1.9, 0]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setScale(0.4);
        setPosition([0, -1, 0]);
      } else {
        setScale(0.5);
        setPosition([0, -1.9, 0]);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return <primitive object={scene} scale={scale} position={position} />;
};

const App = () => {
  const [cameraPosition, setCameraPosition] = useState([0, 2, 5]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCameraPosition([-1, 1.5, 3]);
      } else {
        setCameraPosition([-3, 1.5, 3]);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="relative h-screen w-full bg-black">
      <Canvas camera={{ position: cameraPosition, fov: 60 }}>
        <ambientLight intensity={0.5} />
        <directionalLight position={[2, 2, 2]} />
        {/* OrbitControls con autoRotate habilitado */}
        <OrbitControls autoRotate={true} autoRotateSpeed={1.5} enableZoom={false} enablePan={false} enableRotate={false} />
        <Model />
      </Canvas>

      <footer className="absolute bottom-4 w-full text-center text-white">
        <p className="text-sm">
          © {new Date().getFullYear()} - Portafolio de Jose David. Todos los derechos reservados.
        </p>
        <p className="text-sm mt-1">
          Hecho con <span className="text-red-500">❤</span> y React + Three.js
        </p>
        <div className="mt-3 flex justify-center gap-6">
          <a href="https://github.com/davidas56" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition duration-300">
            GitHub
          </a>
          <a href="https://www.linkedin.com/in/davidas156" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition duration-300">
            LinkedIn
          </a>
        </div>
      </footer>
    </div>
  );
};

export default App;
